import { apiRequest } from './api';

/**
 * Fetch all active collections for the public browse/discover view.
 * No authentication required.
 */
export function listPublicCollections() {
    console.log('Fetching public collections');
    return apiRequest('/public/collections', { authenticated: false });
}

/**
 * Fetch a single collection's public landing page data by slug.
 * No authentication required.
 */
export function getPublicCollection(slug) {
    return apiRequest(`/public/collections/${encodeURIComponent(slug)}`, {
        authenticated: false,
    });
}